import HttpClient from "@/common/boot/HttpClient"

const listarGrupos = async({ commit }, payload) => {

    commit('CARREGANDO', true);

    await HttpClient.get('/app/grupo-rotas', payload).then(response => {
            commit('LISTAR_DADOS', response.data.data);
            return response;
        })
        .finally(() => {
            commit('CARREGANDO', false);
        });
}

const excluirGrupos = async({ dispatch }, payload) => {
    let qtdRows = payload.length;
    for (let i = 0; i < qtdRows; ++i) {
        await excluir(payload[i]);
    }

    dispatch('listarGrupos');
}

const excluir = async(linha) => {
    const resp = await HttpClient.delete(`/app/grupo-rotas/${linha.id}`).then(response => { return response; });
    return resp;
}

const salvarGrupo = async({ commit }, payload) => {

    commit('CARREGANDO', true);

    return await HttpClient.post('/app/grupo-rotas', payload).then(response => {
            commit('INSERIR_GRUPO', response.data.data);
            return response;
        })
        .finally(() => {
            commit('CARREGANDO', false);
        });
}

const recuperarGrupo = ({ commit, state }, payload) => {
    const grupo = state.items.filter(grupo => grupo.id === payload.id);
    if (grupo.length) {
        commit('INSERIR_GRUPO_SELECIONADO', ...grupo);
        return true;
    }

    return false;
}

const atualizarGrupo = async({ commit }, payload) => {
    commit('CARREGANDO', true);
    return await HttpClient.put(`/app/grupo-rotas/${payload.id}`, payload).then(response => {
            commit('ATUALIZAR_GRUPO', response.data.data);
            return response;
        })
        .finally(() => {
            commit('CARREGANDO', false);
        })
}

const associarRotaAoGrupo = ({ commit }, payload) => {
    commit('BUSCANDO', true);

    HttpClient.post(`/app/grupo-rotas/${payload.grupoRotaId}/associar-rotas`, payload).then(response => {
      return response;
    })
    .finally( () => {
      commit('BUSCANDO', false);
    });
  }

export {
    listarGrupos,
    excluirGrupos,
    salvarGrupo,
    recuperarGrupo,
    atualizarGrupo,
    associarRotaAoGrupo
}